// Kategorie-Mapping für korrekte Anzeige
export const categoryLabels = {
  'fruehstueck': 'Frühstück',
  'mittagessen': 'Mittagessen',
  'abendessen': 'Abendessen',
  'dessert': 'Dessert',
  'vorspeise': 'Vorspeise',
  'snack': 'Snack',
};

// Funktion zum Abrufen des Labels
export const getCategoryLabel = (categoryId) => {
  if (!categoryId) return '';
  
  // Wenn das Label bereits definiert ist, verwende es
  if (categoryLabels[categoryId]) {
    return categoryLabels[categoryId];
  }
  
  // Ansonsten: Erster Buchstabe groß
  return categoryId.charAt(0).toUpperCase() + categoryId.slice(1);
};

// Kategorien für Dropdowns
export const categories = [
  { id: 'fruehstueck', name: 'Frühstück' },
  { id: 'mittagessen', name: 'Mittagessen' },
  { id: 'abendessen', name: 'Abendessen' },
  { id: 'dessert', name: 'Dessert' },
  { id: 'vorspeise', name: 'Vorspeise' },
  { id: 'snack', name: 'Snack' },
];

// Für Filter (mit "Alle")
export const categoryFilters = [
  { id: 'alle', name: 'Alle Kategorien' },
  ...categories
];
